import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, input, output, signal } from '@angular/core';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-dialog-wrapper',
    templateUrl: './dialog-wrapper.component.html',
    imports: [CdkDrag, CdkDragHandle, TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DialogWrapperComponent {
    public heading = input.required<string>();
    public description = input<string>();
    public confirmLabel = input.required<string>();
    public cancelLabel = input.required<string>();
    public width = input<string>('500px');

    public confirmed = output<void>();
    public cancelled = output<void>();
    public confirmDisabled = input<boolean>(false);

    protected minimized = signal(false);

    private dialogRef = inject(MatDialogRef, { optional: true });

    public minimize(): void {
        this.minimized.set(true);
        if (this.dialogRef) {
            this.dialogRef.addPanelClass('dialog-minimized');
        }
    }

    public maximize(): void {
        this.minimized.set(false);
        if (this.dialogRef) {
            this.dialogRef.removePanelClass('dialog-minimized');
        }
    }

    public onCancel(): void {
        this.cancelled.emit();
    }

    public onConfirm(): void {
        this.confirmed.emit();
    }
}
